var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"corr-wrap"},[_c('div',{ref:"host",staticClass:"correccion-host"}),(_vm.error)?_c('p',{staticClass:"corr-error"},[_vm._v(" No pudimos cargar el detalle de Corrección de Tests. Inicia sesión y corrige tu próximo test: los primeros informes son gratis. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }